import React, { PropsWithChildren } from 'react';
import { Panel as PrimePanel } from 'primereact/panel';
import { Info } from './Info';
import { IntlShape, useIntl } from 'react-intl';
import { getHelp } from '../../../../util/intl.utils';
import { HelpToolTip } from '../../../components/HelpToolTip';

interface Props {
  title: string;
  className?: string;
  toggleable?: boolean;
  key?: string | number;
  collapsed?: boolean;
}

export const Panel = (props: PropsWithChildren<Props>): React.ReactNode => {
  const intl: IntlShape = useIntl();
  const help: string = getHelp(intl, `${props.title}.help`);


  const header = (options) => {
        const className = `${options.className} justify-content-space-between`;
        return (
          <div className={className}>
            <div className={'flex gap-1'}>
              <span>{intl.formatMessage({ id: `${props.title}.label` })}</span>
            </div>
            <div className={'flex gap-1 align-content-center'}>
              <div className={'flex align-items-center'}>
                {help && <HelpToolTip for={props.title} help={help} />}
              </div>
              {options.togglerElement}
            </div>
          </div>
        );
  }

  return (
    <PrimePanel
      headerTemplate={header}
      className={props.className}
      toggleable={props.toggleable}
      collapsed={props.collapsed}
      pt={{content: {className: 'flex flex-column gap-3 p-2 pt-4'}}}
    >
      {props.children}
    </PrimePanel>
  );
};
